(function () {
  function init(root) {
    var size = parseInt(root.getAttribute('data-bundle-size'), 10) || 3;
    var variantId = root.getAttribute('data-variant-id');
    var price = parseInt(root.getAttribute('data-price'), 10) || 0;
    var currency = root.getAttribute('data-currency') || 'EGP';

    var meta = root.querySelector('[data-bundle-meta]');
    var slotsEl = root.querySelector('[data-bundle-slots]');
    var submit = root.querySelector('[data-bundle-submit]');
    var btnLabel = root.querySelector('[data-bundle-btn-label]');
    var errorEl = root.querySelector('[data-bundle-error]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-pick]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-card]'));

    if (!submit || !slotsEl) return;

    var picks = [];

    function money(cents) {
      try {
        return new Intl.NumberFormat('en', { style: 'currency', currency: currency, minimumFractionDigits: 2 }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2) + ' ' + currency;
      }
    }

    function countFor(variantId) {
      return picks.filter(function (p) { return p.variant === variantId; }).length;
    }

    function render() {
      var full = picks.length >= size;

      chips.forEach(function (chip) {
        if (chip.hasAttribute('disabled')) return;
        var n = countFor(chip.getAttribute('data-variant'));
        var badge = chip.querySelector('[data-chip-count]');
        chip.classList.toggle('is-selected', n > 0);
        chip.classList.toggle('is-locked', full && n === 0);
        if (badge) {
          if (n > 1) { badge.textContent = 'x' + n; badge.hidden = false; }
          else { badge.hidden = true; }
        }
      });

      cards.forEach(function (card) {
        var owned = Array.prototype.slice.call(card.querySelectorAll('[data-pick]')).map(function (c) {
          return c.getAttribute('data-variant');
        });
        var numbers = [];
        picks.forEach(function (p, i) {
          if (owned.indexOf(p.variant) !== -1) numbers.push(i + 1);
        });
        card.classList.toggle('is-picked', numbers.length > 0);
        var wrap = card.querySelector('[data-card-badges]');
        if (wrap) {
          wrap.innerHTML = numbers.map(function (n) {
            return '<span class="bundle-card__badge">' + n + '</span>';
          }).join('');
        }
      });

      slotsEl.innerHTML = '';
      for (var i = 0; i < size; i++) {
        var slot = document.createElement('div');
        slot.className = 'bundle-slot';
        var p = picks[i];
        if (p) {
          slot.classList.add('is-filled');
          slot.setAttribute('title', p.title + ' / ' + p.size);
          slot.innerHTML =
            (p.img ? '<img src="' + p.img + '" alt="">' : '') +
            '<span class="bundle-slot__size">' + p.size + '</span>' +
            '<button type="button" class="bundle-slot__remove" aria-label="Remove pick ' + (i + 1) + '">&times;</button>';
          (function (index) {
            slot.querySelector('.bundle-slot__remove').addEventListener('click', function () {
              picks.splice(index, 1);
              if (errorEl) errorEl.hidden = true;
              render();
            });
          })(i);
        } else {
          slot.innerHTML = '<span class="bundle-slot__num">' + (i + 1) + '</span>';
        }
        slotsEl.appendChild(slot);
      }

      if (meta) meta.textContent = picks.length + ' OF ' + size + ' SELECTED';
      submit.disabled = picks.length !== size;
      if (btnLabel) {
        btnLabel.textContent = picks.length === size
          ? 'ADD BUNDLE - ' + money(price)
          : 'SELECT ' + (size - picks.length) + ' MORE';
      }
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        if (chip.hasAttribute('disabled')) return;
        if (picks.length >= size) return;
        picks.push({
          variant: chip.getAttribute('data-variant'),
          title: chip.getAttribute('data-title'),
          size: chip.getAttribute('data-size'),
          img: chip.getAttribute('data-img')
        });
        if (errorEl) errorEl.hidden = true;
        render();
      });
    });

    submit.addEventListener('click', function () {
      if (picks.length !== size) return;

      var properties = {};
      picks.forEach(function (p, i) {
        properties['Pick ' + (i + 1)] = p.title + ' / ' + p.size;
      });

      submit.disabled = true;
      if (btnLabel) btnLabel.textContent = 'ADDING...';

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: properties }] })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.description || data.message || 'Could not add bundle');
            return data;
          });
        })
        .then(function () {
          window.location.href = window.Shopify.routes.root + 'cart';
        })
        .catch(function (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          render();
        });
    });

    render();
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-bundle-root]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
